// Builds the invitation-email logo image. The logo is served by the (anonymous)
// Artifact/DownloadLogo endpoint so it renders in the editor, the previews, and
// the actual email. Kept as a pure function so it can be unit tested.

export const buildInviteLogoUrl = (baseUrl, fileName) =>
  `${baseUrl}/Artifact/DownloadLogo?fileName=${encodeURIComponent(fileName)}`

// Centered, per the Figma header treatment. The inline text-align survives into the
// sent email (Quill is configured to emit alignment as inline style, not a class).
export const buildInviteLogoHtml = (baseUrl, fileName) =>
  `<p style="text-align: center;"><img src="${buildInviteLogoUrl(baseUrl, fileName)}" width="180" alt="Logo" /></p>`

// What we actually paste into the editor. Quill's dangerouslyPasteHTML merges the
// first and last pasted blocks into the surrounding text, so wrap the logo between
// blank paragraphs: they absorb that merge and the logo stays a standalone centered
// block even when inserted in the middle of a paragraph.
export const buildInviteLogoPasteHtml = (baseUrl, fileName) =>
  `<p><br></p>${buildInviteLogoHtml(baseUrl, fileName)}<p><br></p>`
